const headers = {
  name: "Accounts Receivable",
  components: [
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
  ],
  navigate: {
    tabs: [
      {
        name: "General Ledger",
        path: "/app/common/reports",
      },
      {
        name: "Trial Balance",
        path: "/app/common/reports/trail-balance",
      },
      {
        name: "Balance Sheet",
        path: "/app/common/reports/balance-sheet",
      },
      {
        name: "Profit & Loss",
        path: "/app/common/reports/profit-loss",
      },
      {
        name: "AR Report",
        path: "",
      },
      {
        name: "AP Report",
        path: "/app/common/reports/ap-report",
      },
      {
        name: "Overall Transaction Report",
        path: "/app/common/reports/overall-transaction",
      },
      {
        name: "Day Book Report",
        path: "/app/common/reports/day-book",
      },
    ],
    total: [
      { value: 0, label: "Total Receivable" },
      { value: 0, label: "Overdue Amount" },
      { value: 0, label: "Total Customers" },
    ],
  },
};

export default headers;
